import {Component, input, output, ChangeDetectionStrategy} from "@angular/core";
import {LorenAsset} from "../loren-assets/interfaces/loren-asset.interface";

@Component({
    selector: "map-marker",
    template: `
        <div class="marker-pin"></div>
        <img [src]="asset().avatar ?? '/icon-96x96.png'" [alt]="asset().name"/>
    `,
    styles: `
        :host {
            position: relative;
            display: block;
            width: 40px;
            height: 40px;
        }

        .marker-pin {
            width: 40px;
            height: 40px;
            border-radius: 50% 50% 50% 0;
            background: var(--mat-button-filled-container-color);
            position: absolute;
            transform: rotate(-45deg);
            left: 50%;
            top: 50%;
            margin: -15px 0 0 -15px;
        }

        .marker-pin::after {
            content: "";
            width: 34px;
            height: 34px;
            margin: 3px 0 0 3px;
            background: white;
            position: absolute;
            border-radius: 50%;
        }

        img {
            position: absolute;
            width: 34px !important;
            height: 34px;
            left: 8px;
            top: 8px;
            border-radius: 50%;
            object-fit: cover;
            z-index: 1;
        }
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    host: {
        '(click)': 'clicked.emit(asset())',
    },
})
export class MapMarker {
    // TODO: Ensure this pin points exactly at the location on the map. I think currently it's an approximation
    asset = input.required<LorenAsset>();
    clicked = output<LorenAsset>();
}